import React from "react";
import { Col, Container, Row , FormGroup, Button} from "react-bootstrap";
import { Input, Select, Radio, Checkbox } from 'antd';
import { Breadcrumb, TechniHeader, TechniFooter,ImageElement } from "../../components";
import TextArea from "antd/lib/input/TextArea";

function Existing() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Existing Company',
        },
    ]; 
    return (
        <>  
            <TechniHeader/>
            <main className="becomePage becomePage_fan">
                <Container>
                    <Breadcrumb title="Existing Company" breadcrumb={breadcrumb}/>
                    <div className="becomePage_inner">
                        <div className="becomePage_head text-center">
                            <h2>Become A <span>Company Partner</span></h2>
                            <h3 className="mx-auto w-100">Online gathering place for the best home service providers.</h3>
                             </div>
                        <div className="becomePage_steps">
                               <div className="becomePage_steps_form w-100 mx-auto">
                               <p className="font-sm becomePage_txt">Looking to change how you gain new business and provide service to customers? To learn more about our system and how we can help complete the info below.</p>
                                <div className="becomePage_steps_items">
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label">Company Name</h5>
                                        <Row>
                                            <Col sm={12}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Company</label>
                                                    <Input size="large" placeholder="Company" value="US High School" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label">Contact Name</h5>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">First Name<span className="text-650">*</span></label>
                                                    <Input size="large" placeholder="First Name" value="BRIAN"/>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Last Name</label>
                                                    <Input size="large" placeholder="Last Name" value="MATHEW"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>                                    
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label">Do You Own This Business?</h5>
                                        <Row>
                                            <Col sm={12}>
                                                <FormGroup className="form-group">
                                                    <Radio.Group name="radiogroup" defaultValue={1}>
                                                        <Radio value={1} checked>Yes</Radio>
                                                        <Radio value={2}>No</Radio>
                                                    </Radio.Group>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label">Address</h5>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Address Line 1</label>
                                                    <Input size="large" placeholder="Address Line 1"/>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Address Line 2</label>
                                                    <Input size="large" placeholder="Address Line 2"/>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={12}>
                                                <Row>
                                                    <Col sm={4}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">City</label>
                                                            <Input size="large" placeholder="City"/>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">State</label>
                                                            <Select size="large" className="w-100" placeholder="State"
                                                                options={[
                                                                    {
                                                                        value: '1',
                                                                        label: 'Alabama',
                                                                    },
                                                                    {
                                                                        value: '2',
                                                                        label: 'Alaska',
                                                                    },
                                                                    {
                                                                        value: '3',
                                                                        label: 'Arizona',
                                                                    },
                                                                    {
                                                                        value: '4',
                                                                        label: 'Arkansas',
                                                                    },
                                                                    {
                                                                        value: '5',
                                                                        label: 'California',
                                                                    },
                                                                    {
                                                                        value: '6',
                                                                        label: 'Colorado',
                                                                    },
                                                                ]}
                                                            />
                                                        </FormGroup>
                                                    </Col>  
                                                    <Col sm={4}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Zip Code</label>
                                                            <Input size="large" placeholder="Zip Code"/>
                                                        </FormGroup>
                                                    </Col>                                                     
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">Contact</h5>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup className="form-group form-group-number">
                                                    <label className="ant-label">Mobile Number</label>
                                                    <div className="position-relative">
                                                        <Input size="large" value="1234567890" placeholder="Number" />
                                                        <div className="form-cstm position-absolute top-0 left-0 d-flex">
                                                            <Select size="large" className="w-100" placeholder="+91"
                                                                options={[
                                                                    {
                                                                        value: 'India',
                                                                        label: '+91',
                                                                    },
                                                                    {
                                                                        value: 'UK',
                                                                        label: '+99',
                                                                    }
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </Col>                                            
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Email</label>
                                                    <Input size="large" placeholder="Email" value="aditi@mailinator.com"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">Type Of Home Service You Provide?</h5>
                                        <FormGroup className="form-group">
                                            <Radio.Group name="radiogroup" defaultValue={1}>
                                                <Radio value={1} checked>HVAC</Radio>
                                                <Radio value={2}>Plumbing</Radio>
                                                <Radio value={3}>HandyMan</Radio>
                                                <Radio value={4}>Electrical</Radio>
                                                <Radio value={5}>Other</Radio>
                                            </Radio.Group>
                                        </FormGroup>                                        
                                        <Row>
                                            <Col md={12}>
                                                <h5 className="becomePage_steps_label pt-md-3">If “Other” Please Provide Info</h5>
                                                <FormGroup className="form-group">
                                                    <Input size="large" placeholder="Responsibilities"/>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <h5 className="becomePage_steps_label pt-md-3">How Many Years In Business?<span className="text-650">*</span></h5>
                                                <FormGroup className="form-group">
                                                    <Select size="large" className="w-100" placeholder="Select"
                                                        options={[
                                                            {
                                                                value: '1',
                                                                label: 'Less Than 2 Years',
                                                            },
                                                            {
                                                                value: '2',
                                                                label: '2-4 years',
                                                            },
                                                            {
                                                                value: '3',
                                                                label: '5-10 years',
                                                            },
                                                            {
                                                                value: '4',
                                                                label: '10 or more years',
                                                            }
                                                        ]}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">How Could Good Guys Home Services Benefit You?</h5>
                                        <Row>
                                            <Col md={4}>
                                                <FormGroup className="form-group mb-md-3 mb-2 ">
                                                    <Checkbox>Bring in more customers</Checkbox>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="form-group mb-md-3 mb-2 ">
                                                    <Checkbox>Increase profit</Checkbox>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="form-group mb-md-3 mb-2 ">
                                                    <Checkbox>Software that automates my business</Checkbox>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="form-group mb-md-3 mb-2 ">
                                                    <Checkbox>Increase technicians profitability</Checkbox>
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup className="form-group">
                                                    <Checkbox>Other</Checkbox>
                                                </FormGroup>
                                            </Col>
                                        </Row>              
                                    </div>
                                </div>
                                <div className="becomePage_steps_items">
                                    <h4 className="mb-0">Which Good Guys Member Referred You?</h4>
                                    <span className="becomePage_steps_items_subtxt">If applicable, who influenced your decision to consider joining Good Guys?</span>
                                    <div className="becomePage_steps_items_list">
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">First Name<span className="text-650">*</span></label>
                                                    <Input size="large" placeholder="First Name" value="BRIAN"/>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Last Name</label>
                                                    <Input size="large" placeholder="Last Name" value="MATHEW"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label pt-lg-3">How Did You Learn About Good Guys Home Services?</h5>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup className="form-group">
                                                    <Select size="large" className="w-100" placeholder="Select"
                                                        options={[
                                                            {
                                                                value: '1',
                                                                label: 'Good Guys Member',
                                                            },
                                                            {
                                                                value: '2',
                                                                label: 'Internet Search',
                                                            },
                                                            {
                                                                value: '3',
                                                                label: 'Facebook',
                                                            },
                                                            {
                                                                value: '4',
                                                                label: 'TV',
                                                            },
                                                            {
                                                                value: '5',
                                                                label: 'Radio',
                                                            },
                                                            {
                                                                value: '6',
                                                                label: 'Local Magazine',
                                                            },
                                                            {
                                                                value: '7',
                                                                label: 'Other',
                                                            },
                                                        ]}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">Any Certifications Or Local Trade License? (Please List)</h5>
                                        <Row>
                                            <Col sm={12}>
                                                <FormGroup className="form-group">
                                                    <TextArea size="large" placeholder="Enter The Text"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">Any Additional Info You Would Like Us To Know?</h5>
                                        <Row>
                                            <Col sm={12}>
                                                <FormGroup className="form-group">
                                                    <TextArea size="large" placeholder="Enter The Text"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className="becomePage_steps_items">
                                    <div className="becomePage_steps_items_list">
                                        <h4 className="mb-2 ">Disclaimer and Electronic Signature</h4>
                                        <p className="mb-0 ft-14 disclaimer">I certify that my answers are true and complete to the best of my knowledge. I authorize Good Guys Home Services to perform a background check and driving record. If this application leads to acceptance to join Good Guys Home Services, I understand that false or misleading information in my application or interview may result in my release.</p>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm mb-2">I Agree <span className="text-650">*</span></h5>
                                        <Row>
                                            <Col sm={12}  className="mb-3 mb-xl-0">
                                                <Checkbox>Yes</Checkbox>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="becomePage_steps_items_list">
                                        <h5 className="becomePage_steps_label font-sm">Name <span className="text-650">*</span></h5>
                                        <Row>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">First Name<span className="text-650">*</span></label>
                                                    <Input size="large" placeholder="First Name" value="BRIAN"/>
                                                </FormGroup>
                                            </Col>
                                            <Col sm={6}>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label">Last Name</label>
                                                    <Input size="large" placeholder="Last Name" value="MATHEW"/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <Button type="submit" variant="primary">Submit</Button>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>                   
                </Container>
            </main>  
            <TechniFooter/>
        </>
    );
  }
  
  export default Existing;